<template>
  <div class="columns is-multiline my-0">
    <div class="address_search mb-100">
      <form-field-input
        label="Street Address"
        class="column is-full"
        v-model="searchQuery"
      ></form-field-input>

      <div
        v-if="showResults"
        class="column is-full address_search--results"
      >
        <p
          v-for="result in addresses"
          tabindex="-1"
          @click="applyAddress(result)"
          class="address_search--results--item dont-close-search-results"
        >
          <strong class="dont-close-search-results">{{ result.house }} {{ result.street }},</strong>
          <small class="dont-close-search-results">{{ result.city }}, {{ result.state }}, {{ result.zip }}</small>
        </p>
      </div>
    </div>

    <form-field-input
      v-if="includeLine2"
      :label="line2Label"
      class="column is-full"
      v-model="entity.line_2"
      input-id="address_line_2"
      :validation-errors="validationErrors.line_2"
    ></form-field-input>

    <form-field-input
      label="City"
      :class="['column', cityClass]"
      v-model="entity.city"
      :validation-errors="validationErrors.city"
    ></form-field-input>

    <form-field-input
      label="State"
      :class="['column', stateClass]"
      v-model="entity.state"
      :validation-errors="validationErrors.state"
    ></form-field-input>

    <form-field-input
      label="Postcode"
      :class="['column', postcodeClass]"
      v-model="entity.postcode"
      :validation-errors="validationErrors.postcode"
    ></form-field-input>

    <form-field-input
      v-if="includeCounty"
      label="County"
      class="column is-6"
      v-model="entity.county"
      :validation-errors="validationErrors.county"
    ></form-field-input>
  </div>
</template>

<script>
export default {
  name: "FormFieldAddress",
  props: {
    entity: {
      type: Object,
      required: true
    },
    includeCounty: {
      type: Boolean,
      default: false
    },
    includeLine2: {
      type: Boolean,
      default: false
    },
    line2Label: {
      type: String,
      default: null
    },
    validationErrors: {
      type: Object,
      required: true
    }
  },
  watch: {
    // This is important that this is in the LayoutPage via a global Listener
    '$store.state.reiRealEstateOptionsOpen' (value) {
      this.showResults = value;
    }
  },
  mounted() {
    if (this.isRecord) {
      this.query = this.entity.line_1;
    }
    if (this.isContact) {
      this.query = this.entity.street;
    }
  },
  data() {
    return {
      apiUrl: 'https://api.realestateapi.com/v2/AutoComplete',
      apiKey: process.env.MIX_REAL_ESTATE_API_KEY,
      query: null,
      results: [],
      showResults: false,
    }
  },
  computed: {
    cityClass() {
      return this.includeCounty ? 'is-6' : 'is-5';
    },
    stateClass() {
      return this.includeCounty ? 'is-6' : 'is-3';
    },
    postcodeClass() {
      return this.includeCounty ? 'is-6' : 'is-4';
    },
    isRecord() {
      return this.entity.line_1 || this.entity.line_1 === null || this.entity.line_1 === '';
    },
    isContact() {
      return this.entity.street || this.entity.street === null || this.entity.street === '';
    },
    searchQuery: {
      get: function () {
        return this.query;
      },
      set: function (query) {
        this.query = query;

        if (this.isRecord) {
          this.entity.line_1 = this.query;
        } else if (this.isContact) {
          this.entity.street = this.query
        }

        this.search();
      }
    },
    addresses: {
      get: function () {
        return this.results;
      },
      set: function (results) {
        this.results = results.filter(result => result.searchType === 'A');
      }
    }
  },
  methods: {
    search() {
      if (!this.searchQuery) {
        this.results = [];
      }
      if (this.searchQuery.length < 3) {
        return;
      }

      const requestOptions = {
        method: "POST",
        mode: 'cors',
        headers: {
          "x-api-key": this.apiKey,
          "Content-Type": "application/json"
        },
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify({search: this.searchQuery})
      };

      fetch(this.apiUrl, requestOptions)
        .then(response => {
          response.json().then(data => {
            this.addresses = data.data || [];
            this.showResults = true;
          }).catch(e => {
            console.error(e)
          });
        }).catch(e => {
        console.error(e)
      });
    },
    hideResults() {
      this.showResults = false;
    },
    applyAddress(address) {
      const line1 = address.house + ' ' + address.street;

      if (this.isRecord) {
        this.entity.line_1 = line1;
      } else if (this.isContact) {
        this.entity.street = line1 // address.house + ' ' + address.street;
      }
      this.entity.city = address.city;
      this.entity.state = address.state;
      this.entity.county = address.county;
      this.entity.postcode = address.zip;

      this.query = line1;

      this.hideResults()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.address_search {
  position: relative;
  width: 100%;

  &--results {
    position: absolute;
    top: 100%;
    left: 0.75rem;
    right: 0.75rem;
    z-index: 99999999999;
    width: calc(100% - 1.5rem);
    padding: 10px;
    background-color: $white;
    box-shadow: $box-shadow;

    &--item {
      margin-bottom: 3px;
      padding-bottom: 3px;
      border-bottom: 1px solid $border;
      color: $text-muted;
      font-size: 0.75rem;
      line-height: 1.3;
      cursor: pointer;

      strong {
        color: inherit;
      }

      &:hover {
        color: $primary;
      }
    }
  }
}
</style>
